import Vue from 'vue'
import VueI18n from 'vue-i18n' 
import store from '@/store'       //引入vue-i18n
Vue.use(VueI18n);    //通过插件的形式挂载
/*---------使用语言包-----------*/
import zh_tc from '@/biz/lang/zh';
import en from '@/biz/lang/en';
const i18n = new VueI18n({
   locale: store.getters.language,    // 语言标识
   //this.$i18n.locale // 通过切换locale的值来实现语言切换
   messages: {
    //  'zh_tc': require('@/biz/lang/zh'),   // 中文语言包
    //  'en': require('@/biz/lang/en')    // 英文语言包
    zh_tc,
    en
   }
})

export default i18n